export default __webpack_public_path__ + "static/media/search.ab1ed72a.svg";